module.exports = __webpack_public_path__ + "media/dorobek/assets/images/avatar-placeholder-negative-27663c8b5013485f3337c8e55da9eedc.png";